import { CSSDirective, cssPartial } from '@microsoft/fast-element';
export class CSSVarsTokenMapper extends CSSDirective {
    constructor(tokenMap) {
        super();
        this.tokenMap = tokenMap;
    }
    createTokenPartial(key, value) {
        return cssPartial `${key}: ${value}`;
    }
    createTokensCSS() {
        const styles = [];
        for (const [key, value] of Object.entries(this.tokenMap)) {
            styles.push(this.createTokenPartial(key, value).createCSS());
        }
        return styles;
    }
    createCSS() {
        return this.createTokensCSS().join(';');
    }
}
